import { type FC, useState } from "react";
import { TextButton } from "@root/shared/components/TextButton";
import { Icon } from "@root/shared/components/Icon";
import { UserHiddenConfirmationModal } from "@clientFrontend/features/scout/components/UserHiddenConfirmationModal";
import * as styles from "./styles.css";

type Props = {
  isHidden: boolean;
  isLoading: boolean;
  onClickUserHiddenTrigger: () => void;
};

export const ResultUserControlButton: FC<Props> = ({
  isHidden,
  isLoading,
  onClickUserHiddenTrigger,
}) => {
  const [isShowConfirmModal, setIsShowConfirmModal] = useState(false);

  const onClickUserHiddenButton = () => {
    if (isHidden && onClickUserHiddenTrigger) {
      // 非表示ユーザーの場合、確認モーダルを出さずに解除リクエストを送る
      onClickUserHiddenTrigger();
    } else {
      // 非表示ではないユーザーの場合、確認モーダルを出す
      setIsShowConfirmModal(true);
    }
  };

  // 非表示確認モーダルで「はい」を押下した際に発火
  const onClickConfirmedButton = () => {
    setIsShowConfirmModal(false);
    if (onClickUserHiddenTrigger) {
      // 非表示にするリクエストを送る
      onClickUserHiddenTrigger();
    }
  };

  return (
    <>
      <TextButton
        className={isLoading ? styles.loadingButton : styles.button}
        onClick={onClickUserHiddenButton}
        size="small"
        disabled={isLoading}
      >
        <Icon name="human-minus" fontSize="20px" />
        {!isHidden ? (
          <p className={styles.text}>この求職者を非表示にする</p>
        ) : (
          <p className={styles.text}>非表示を解除する</p>
        )}
      </TextButton>
      {isShowConfirmModal && (
        <UserHiddenConfirmationModal
          isShow={isShowConfirmModal}
          onClickModalClose={() => setIsShowConfirmModal(false)}
          onClickUserHiddenTrigger={() => onClickConfirmedButton()}
        />
      )}
    </>
  );
};
